import { render } from "./SeatLockOverlay.vue?vue&type=template&id=31980333&scoped=true"
import script from "./SeatLockOverlay.vue?vue&type=script&lang=js"
export * from "./SeatLockOverlay.vue?vue&type=script&lang=js"

import "./SeatLockOverlay.vue?vue&type=style&index=0&id=31980333&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31980333"]])

export default __exports__